import { isBrandFile } from '@hub/common';
import { protocolBrandUrl } from './protocolBrandUrl';
import type { BrandFile } from '@hub/common';

/** A protocol's brand from its brand copy in Storage; null for a protocol
 *  without a brand and for a missing copy. */
export const fetchProtocolBrand = async (
  protocolId: string
): Promise<BrandFile | null> => {
  const response = await fetch(protocolBrandUrl(protocolId));
  if (response.status === 404) return null;
  if (!response.ok)
    throw new Error(
      `Brand copy request failed with ${response.status.toString()}`
    );
  const body: unknown = await response.json();
  if (body === null) return null;
  if (!isBrandFile(body)) throw new Error('Not a brand file');
  return body;
};
